module.exports = __webpack_public_path__ + "static/media/Jamaika-Color-Flat.ae645f14.png";